import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import {
  IEFTPaymentDetails,
  IOrder,
  IOrderHandshakeOffer,
  IOrderMessage,
  IPaginatedResponse,
} from '@boma/website/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  listOrders(
    operatingEntityId: string,
    locationId: string,
    page: number = 1,
    perPage: number = 25,
    query: string | null = null,
    batchId: number | null = null
  ) {
    const params = {
      direction: 'Inbound',
      locationId,
    };

    let queryParams = [];
    let urlQuery = '';

    if (query) {
      params['query'] = query;
    }
    if (batchId) {
      params['batchId'] = Number(batchId);
    }

    if (page) {
      queryParams.push(`page=${page}`);
    }

    if (perPage) {
      queryParams.push(`perPage=${perPage}`);
    }

    if (queryParams.length > 0) {
      urlQuery = `?${queryParams.join('&')}`;
    }

    return this.httpClient.post<IPaginatedResponse<IOrder>>(
      `${this.base}api/v${this.version}/${operatingEntityId}/Orders${urlQuery}`,
      params
    );
  }

  getOrder(operatingEntityId: string, orderId: string) {
    const params = {
      direction: 'Inbound',
    };

    return this.httpClient.get<IOrder>(
      `${this.base}api/v${this.version}/${operatingEntityId}/Orders/${orderId}`,
      {
        params,
      }
    );
  }

  cancelOrder(operatingEntityId: string, orderId: string) {
    return this.httpClient.post<IOrder>(
      `${this.base}api/v${this.version}/${operatingEntityId}/Orders/${orderId}/ChangeStatus/Cancelled`,
      {
        direction: 'Inbound',
      }
    );
  }

  getOrderEFTDetails(operatingEntityId: string, orderId: string) {
    return this.httpClient.get<IEFTPaymentDetails>(
      `${this.base}api/v${this.version}/${operatingEntityId}/Orders/${orderId}/BankTransferDetails`
    );
  }

  getOrderHandshakeOffer(operatingEntityId: string, orderId: string) {
    return this.httpClient.get<IOrderHandshakeOffer>(
      `${this.base}api/v${this.version}/${operatingEntityId}/Orders/${orderId}/Handshake/Offer`
    );
  }

  loadOrderMessages(
    operatingEntityId: string,
    orderId: string,
    before: Date | string | null = null
  ) {
    let params = {
      direction: 'Inbound',
    };
    if (before) {
      params['dateSearchType'] = 'Before';
      params['date'] = new Date(before).toUTCString();
    }

    return this.httpClient.get<IOrderMessage[]>(
      `${this.base}api/v${this.version}/${operatingEntityId}/Orders/${orderId}/Messages`,
      { params }
    );
  }

  createOrderMessage(
    operatingEntityId: string,
    orderId: string,
    content: string
  ) {
    return this.httpClient.post<IOrderMessage>(
      `${this.base}api/v${this.version}/${operatingEntityId}/Orders/${orderId}/Messages?direction=Inbound`,
      { content }
    );
  }
}
